<template>
  <div class="interview-rating-container">
    <div class="rating">
      <div class="status">
        <div v-if="hasStatus" class="label">{{ ratingStatus }}</div>
        <el-divider v-if="hasStatus" direction="vertical"></el-divider>
        <el-rate
          v-model="score"
          disabled
          class="content"
          :colors="{ [max]: rateColor}"
          :max="max"
        >
        </el-rate>
        <i class="collapse-icon el-icon-arrow-down" :class="!isCollapse  && 'is-collapse'" @click="handleCollapseBtnClick"></i>
      </div>
      <div class="comment" ref="comment" :style="cssStyle">
        <div class="collapse-content">
          <div class="label">{{ $t('common.label.comment') }}</div>
          <div class="content">{{ comment }}</div>
        </div>
      </div>
      <div class="time-container">
        <span class="name">{{ name }}</span>
        <span class="time">{{ moment(time).format('YYYY-MM-DD') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

const INTERVIEW_RATING_STATUS = {
  NOT_RECOMMENDED: 0,
  PENDING: 1,
  RECOMMENDED: 2
}

export default {
  props: {
    totalScore: {
      type: Number,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    rate: {
      type: Number,
      required: false
    },
    comment: {
      type: String,
      required: false
    },
    status: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      moment,
      i18nPrefix: 'admin.application.candidate',
      INTERVIEW_RATING_STATUS,
      max: 6,
      score: this.rate,
      isCollapse: true,
      cssStyle: {
        height: '0px'
      }
    }
  },
  computed: {
    hasStatus () {
      return typeof this.status === 'number'
    },
    ratingStatus () {
      let i18nKey = null
      if (this.status === this.INTERVIEW_RATING_STATUS.NOT_RECOMMENDED) {
        i18nKey = 'NOT_RECOMMENDED'
      } else if (this.status === this.INTERVIEW_RATING_STATUS.PENDING) {
        i18nKey = 'RATE_PENDING'
      } else if (this.status === this.INTERVIEW_RATING_STATUS.RECOMMENDED) {
        i18nKey = 'RECOMMENDED'
      }
      return this.$t(`${this.i18nPrefix}.label.${i18nKey}`)
    },
    rateColor () {
      let color = null
      if (this.status === INTERVIEW_RATING_STATUS.PENDING) {
        // yellow
        color = '#F4A958'
      } else if (this.status === INTERVIEW_RATING_STATUS.NOT_RECOMMENDED) {
        // red
        color = '#E27676'
      } else if (this.status === INTERVIEW_RATING_STATUS.RECOMMENDED) {
        // green
        color = '#51BF82'
      } else {
        color = '#0096CC'
      }
      return color
    }
  },
  created () {

  },
  mounted () {
    this.refreshCollapse()
  },
  methods: {
    handleCollapseBtnClick () {
      this.isCollapse = !this.isCollapse
      this.refreshCollapse()
    },
    refreshCollapse (isNextTick) {
      const collapse = this.isCollapse
      if (collapse) {
        if (this.cssStyle.height) {
          this.cssStyle.height = '0px'
        } else {
          const height = this.$refs.comment.firstElementChild.clientHeight
          if (height) {
            this.cssStyle.height = `${height}px`
            this.$nextTick(() => {
              setTimeout(() => {
                this.cssStyle.height = '0px'
              }, 0)
            })
          } else {
            this.cssStyle.height = '0px'
          }
        }
      } else {
        const el = this.$refs.comment.firstElementChild
        if (!el) {
          if (isNextTick) {
            this.cssStyle.height = null
          } else {
            this.$nextTick(() => this.refreshCollapse(true))
          }
          return
        }
        const height = el.clientHeight
        if (height) {
          this.cssStyle.height = `${height}px`
          this.$nextTick(() => {
            setTimeout(() => {
              this.cssStyle.height = null
            }, 300)
          })
        } else {
          this.cssStyle.height = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.interview-rating-container {
  margin-top: -1px;
  border: 1px solid #E4E7ED;
  font-size: 16px;
  color: #606266;

  &:first {
    margin-top: 0;
  }

  .question-container {
    border-bottom: 1px solid #E4E7ED;
    padding: 25px 40px;
    font-weight: bold;

    .label {
      width: 85px;
    }

    .content {
      margin-left: 15px;
    }

    .question {
      display: flex;
    }

    .answer {
      display: flex;
      margin-top: 20px;
    }
  }

  .rating {
    padding: 25px 40px;

    .status {
      display: flex;
      align-items: center;
      .label {
        width: 160px;
        font-weight: bold;
      }

      .collapse-icon {
        margin-left: auto;
        transition: all .3s;
        cursor: pointer;

        &.is-collapse {
          transform: rotate(-180deg);
        }
      }
    }

    .comment {
      margin-top: 10px;
      transition: height .3s ease-in-out;
      overflow: hidden;

      .label {
        color: #909399;
      }

      .content {
        white-space: pre-wrap;
      }
    }

    .time-container {
      color: #909399;
      margin-top: 10px;

      .time {
        margin-left: 10px;
      }
    }
  }
}
</style>
